module.exports = __webpack_public_path__ + "media/images/banner-hotel-lp-th-cc6447447ad6a77fb560b7be608c4c2a.jpg";